import { DataBean } from "../DataBean";

export class AgreementBalance extends DataBean {
    
    
    

    public async getAgreementBalanceCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAgreementBalanceCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
  
    public async getAgreementBalanceCatalogoPorPropiedadesRender(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getAgreementBalanceCatalogoPorPropiedadesRender_java.util.Map_Number", [properties,maxRows]);
    }
}